import SelectProduct from './containers/SelectProductsContainer';

export default SelectProduct;
